import styled, { css } from 'styled-components/macro';

type InputStyledT = {
  bg?: 'grey';
};

export const InputWrapStyled = styled.div`
  position: relative;
`;

const grey = css`
  background-color: ${({ theme }): string => theme.colors.primary.variant2};
  &:focus {
    outline: 1px solid ${({ theme }): string => theme.colors.primary.variant1};
  }
`;

const inputBackground = {
  grey,
};

export const InputStyled = styled.input<InputStyledT>`
  width: 100%;
  color: ${({ theme }): string => theme.colors.primary.variant11};
  font-size: ${({ theme }): string => theme.fontSize.xl};
  font-weight: ${({ theme }): number => theme.fontWeight.normal};
  font-family: ${({ theme }): string => theme.fontFamily.primary};
  line-height: 22px;
  padding: 0.5rem 0.625rem;
  border-radius: ${({ theme }): string => theme.radius.sm};
  border: ${({ theme }): string => `${theme.borders.sm} ${theme.colors.primary.variant3}`};

  ${({ bg }): ReturnType<typeof css> | string => (bg ? inputBackground[bg] : '')}

  &:focus {
    outline: ${({ theme }): string => `${theme.borders.xs} ${theme.colors.primary.variant8}`};
  }

  &::placeholder {
    color: ${({ theme }): string => theme.colors.primary.variant8};
    font-size: ${({ theme }): string => theme.fontSize.xl};
    font-weight: ${({ theme }): number => theme.fontWeight.normal};
  }

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${({ theme }): string => theme.colors.primary.variant8};
    font-size: ${({ theme }): string => theme.fontSize.xl};
    font-weight: ${({ theme }): number => theme.fontWeight.normal};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${({ theme }): string => theme.colors.primary.variant8};
    font-size: ${({ theme }): string => theme.fontSize.xl};
    font-weight: ${({ theme }): number => theme.fontWeight.normal};
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: ${({ theme }): string => theme.colors.primary.variant8};
    font-size: ${({ theme }): string => theme.fontSize.xl};
    font-weight: ${({ theme }): number => theme.fontWeight.normal};
  }
  :-moz-placeholder {
    /* Firefox 18- */
    color: ${({ theme }): string => theme.colors.primary.variant8};
    font-size: ${({ theme }): string => theme.fontSize.xl};
    font-weight: ${({ theme }): number => theme.fontWeight.normal};
  }
`;

export const IconWrapStyled = styled.div`
  display: inline-flex;
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
`;

export const LabelStyled = styled.label`
  display: block;
  margin-bottom: 0.25rem;
  color: ${({ theme }): string => theme.colors.primary.variant9};
`;

export const RequiredSignStyled = styled.span`
  color: ${({ theme }): string => theme.colors.highlight.variant2};
`;
